// extracted by mini-css-extract-plugin
export var actions = "_2k-0";
export var actionsContainer = "_2k-7";
export var border = "_2k-1";
export var childFullHeight = "_2k-f";
export var collapse = "_2k-2";
export var content = "_2k-a";
export var contentChild = "_2k-e";
export var fullscreen = "_2k-c";
export var hasLeftRadius = "_2k-k";
export var headerContainer = "_2k-3";
export var headerRow = "_2k-5";
export var hidePadding = "_2k-b";
export var navCollapsedGap = "_2k-l";
export var noScrollX = "_2k-m";
export var noScrollY = "_2k-n";
export var noTopPadding = "_2k-i";
export var optOutTopPadding = "_2k-d";
export var pageMain = "_2k-j";
export var pageOuter = "_2k-g";
export var pagePadding = "_2k-8";
export var pageScroll = "_2k-9";
export var profile = "_2k-o";
export var profileContainer = "_2k-p";
export var profileImage = "_2k-q";
export var profileMain = "_2k-r";
export var profileSubtitle = "_2k-t";
export var profileTitle = "_2k-s";
export var showLeftPadding = "_2k-h";
export var tabsPortalSlot = "_2k-6";
export var tabsWrapper = "_2k-4";
export var title = "_2k-u";